import { render, staticRenderFns } from "./ComdeleteAlert.vue?vue&type=template&id=2304e275&scoped=true&"
import script from "./ComdeleteAlert.vue?vue&type=script&lang=js&"
export * from "./ComdeleteAlert.vue?vue&type=script&lang=js&"
import style0 from "./ComdeleteAlert.vue?vue&type=style&index=0&id=2304e275&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304e275",
  null
  
)

export default component.exports